import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import AboutHero from './components/AboutHero';
import AboutContent from './components/AboutContent';
import DomainsSection from './components/DomainsSection';

export default function About() {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-1 pt-20">
        <AboutHero />
        <AboutContent />
        <DomainsSection />
      </main>
      <Footer />
    </div>
  );
}
